import ErrorIcon from '@mui/icons-material/Error';
import {Grid, Typography} from '@mui/material';
import {func, string} from 'prop-types';
import {useNavigate} from 'react-router-dom';

import Button from '../form/buttons/Button/Button';

const ErrorComponent = ({message = 'Une erreur inattendue est survenue.', href = '', onClick, buttonText = 'Retour'}) => {
  const navigate = useNavigate();
  return (
    <Grid container justifyContent="center" alignItems="center" flex={1} direction="column" rowSpacing={3}>
      <ErrorIcon sx={{fontSize: 70}} color="error" />
      <Typography fontWeight="bold" my={3}>
        {message}
      </Typography>
      <Button size="large" variant="contained" color="secondary" onClick={() => (href ? navigate(href) : onClick())}>
        {buttonText}
      </Button>
    </Grid>
  );
};

ErrorComponent.propTypes = {
  message: string,
  href: string,
  onClick: func,
  buttonText: string
};

export default ErrorComponent;
